/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, themeV2, pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui';
// import { hoverTransition } from '../../../../utils/styles/general';



/* ++++++++++ --------------- SIDEBAR SWITCH : STYLES --------------- ++++++++++ */
export default {
	switch: {
		width: '100%',
		padding: `${pxToEm(16)} ${pxToEm(4)}`,
		display: 'flex',
		alignItems: 'center',
		'& #sidebar-switch-inner': {
			width: '100%',
			display: 'flex',
			padding: `${pxToEm(16)} 0`,
			alignItems: 'center',
			flexDirection: 'column',
			'& .desc': {
				width: '100%',
				'& p': {
					color: '#7E92B8',
					fontSize: pxToEm(13),
					textAlign: 'center',
				}
			},
			'& .button': {
				width: '100%',
				height: 'auto',
				whiteSpace: 'initial',
				fontSize: pxToEm(14),
				padding: pxToEm(8),
				background: themeV2.color.base.white,
        color: theme.color.primary.medium.swatch,
        fontWeight: '700',
				border: 'none !important',
				'& span': {
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: pxToEm(4)
				},
				'&:hover, &:active, &:focus': {
					color: theme.color.primary.dark.swatch,
					'& path': {
						fill: `${theme.color.primary.dark.swatch} !important`
					}
				}
			}
		},
		'&.sidebarOpen': {
			'&-false': {
				display: 'none',
				borderRadius: '0',
				width: `calc(100% - ${pxToEm(20)})`,
				padding: replacePXinStringWithEM(`10px 0`),
				'& #sidebar-switch-inner': {
					minHeight: 'auto',
					padding: '0',
					'& .desc': { display: 'none' }
				}
			}
		}
	}
}; 